<template>
  <div class="admin-dashboard">
    <h1>{{ $t("titles.dashboard") | capitalize }}</h1>

    <incident-table class="mb-4" :initial-filters="{ status: 'in_process' }" />

    <community-users-list
      id="admin-dashboard-user-approvals"
      class="mb-4"
      :fetch-params="{ status: 'new', for: 'admin' }"
      :hide-fields="['role', 'status']"
      :initial-filters="{
        updated_at: $dayjs().subtract(2, 'month').toISOString() + '@',
        proof_state: 'unevaluated',
      }"
      :sync-filters-with-url="false"
      :show-generate-csv="false"
      :label="$t('views.admin.dashboard.sections.participants.title')"
    />

    <paginated-table
      v-if="isGlobalAdmin"
      id="admin-dashboard-borrower-approvals"
      class="mb-4"
      endpoint="users"
      :fetch-params="{
        'borrower.submitted_at': '@',
        '!borrower.approved_at': '@',
      }"
      :show-generate-csv="false"
      :label="$t('views.admin.dashboard.sections.borrower.title')"
      :columns="userColumns"
      :extra-filters="userExtraFilters"
      :show-action-column="false"
      @row-clicked="(item) => $router.push(`/admin/users/${item.id}#borrower`)"
    />
    <!--    Users in need of approval of borrower data -->
  </div>
</template>

<script>
import CommunityUsersList from "@/components/Community/CommunityUsersList.vue";
import IncidentTable from "@/components/Incident/IncidentTable.vue";
import PaginatedTable from "@/components/shared/PaginatedTable.vue";
import { Column, Filter } from "@/components/shared/PaginatedTableColumns";
import { capitalize } from "@/helpers/filters";
import { getCommunityAdminFilter } from "@/helpers/permissions/communities";
import { isGlobalAdmin } from "@/helpers/permissions/users";

export default {
  name: "AdminDashboard",
  components: {
    IncidentTable,
    CommunityUsersList,
    PaginatedTable,
  },
  data: function () {
    return {
      userColumns: [
        new Column("id", capitalize(this.$t("lists.id")), "id"),
        new Column("full_name", capitalize(this.$t("users.fields.full_name")), "text"),
        new Column("email", capitalize(this.$t("users.fields.email"))),
        new Column(
          "borrower.submitted_at",
          capitalize(this.$t("borrowers.fields.submitted_at")),
          "date"
        ),
      ],
    };
  },
  computed: {
    userExtraFilters() {
      return [
        new Filter(
          "community_id",
          capitalize(this.$t("communities.fields.community.name")),
          "relation",
          {
            relation: "communities",
            label: "name",
            field: "id",
            params: { ...getCommunityAdminFilter(this.$store.state.user, "read", "id") },
          }
        ),
      ];
    },
    isGlobalAdmin() {
      return isGlobalAdmin(this.$store.state.user);
    },
  },
};
</script>

<style lang="scss"></style>
